import { Customer, PointTransaction, PointTransactionType } from '@api/Customers/Customer';

/**
 * Puntos HISTÓRICOS de un cliente: todo lo que ha recibido en su vida —compras,
 * bienvenida, manuales y ajustes— SIN restar lo canjeado. "Cuántos ha juntado",
 * no "cuántos le quedan" (pedido de Irving, 2026-09-07; viaja al CRM como
 * `contact.puntos_totales` y sale en el Excel y en el historial).
 *
 * Se DERIVA del ledger del wallet: `Earned` + `Initial`. `Spent` guarda la
 * magnitud del canje con su propio tipo, así que ni se suma ni se resta. No hay
 * campo nuevo en el doc ni escritor nuevo: el rebuild de puntos (`PointsHelper`)
 * reconstruye el ledger entero y este número se corrige solo con él.
 *
 * ⚠️ Réplica de lectura de `getCrmLifetimePoints` en krispis-server
 * (`api/ColegaStudio/CrmSync.ts`): misma regla, mismo redondeo. Cambiar una =
 * cambiar la otra.
 */
export const getLifetimePointsFromTransactions = (transactions: PointTransaction[] | undefined): number => {
    const total = (transactions || []).reduce((sum, tx) => {
        if (tx?.type === PointTransactionType.Earned || tx?.type === PointTransactionType.Initial) {
            return sum + (Number(tx.points) || 0);
        }
        return sum;
    }, 0);
    return Math.round(total);
};

export const getLifetimePoints = (customer?: Customer): number =>
    getLifetimePointsFromTransactions(customer?.profile?.wallet?.transactions);
